import gql from "graphql-tag";

export default gql`
    type Thumbnail {
        size: String
        url: String
    }
`
